// extracted by mini-css-extract-plugin
module.exports = {"processTitle":"processTitle[Frida]rlw0Lie3","filter":"filter[Frida]xCDXH_vv","pagination":"pagination[Frida]kJGhKOXa"};